import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

import { tw } from "~/utils";
import { PageButtons } from "./PageButtons";

interface PaginationControlsProps {
  className?: string;
  currentPage: number;
  numPages: number;
  itemsCount: number;
  setPage: (p: number) => void;
}

export const PaginationControls = ({
  currentPage,
  numPages,
  setPage,
  itemsCount,
  className,
}: PaginationControlsProps) => {
  return (
    <nav
      className={tw(
        "flex w-full flex-row justify-between text-gray-700",
        className,
      )}
    >
      <span className="text-footer-text text-base">
        Showing {itemsCount} result(s)
      </span>

      <div className="flex">
        <button
          className="text-indigo disabled:text-soft-lavender flex cursor-pointer flex-row items-center gap-1.5 p-1 hover:opacity-80 disabled:cursor-default"
          onClick={() => setPage(currentPage - 1)}
          disabled={currentPage === 1 || numPages === 0}
          aria-label="Previous"
        >
          <ChevronLeftIcon className="w-6" />
        </button>
        <PageButtons
          currentPage={currentPage}
          numPages={numPages}
          setPage={setPage}
        />
        <button
          className="text-indigo disabled:text-soft-lavender flex cursor-pointer flex-row items-center gap-1.5 p-1 hover:opacity-80 disabled:cursor-default"
          onClick={() => setPage(currentPage + 1)}
          disabled={currentPage === numPages || numPages === 0}
          aria-label="Next"
        >
          <ChevronRightIcon className="w-6" />
        </button>
      </div>
    </nav>
  );
};
